<template>
  <div>
    <h2 class="page-title">小课名单 / 充值</h2>
    <el-card>
      <div class="toolbar">
        <el-input v-model="keyword" placeholder="搜索学生/家长/电话" clearable @clear="loadData" @keyup.enter.native="loadData">
          <el-button slot="append" icon="el-icon-search" @click="loadData" />
        </el-input>
      </div>

      <!-- 桌面端表格 -->
      <el-table :data="list" v-loading="loading" border stripe class="desktop-table">
        <el-table-column prop="name" label="学生" width="100" />
        <el-table-column prop="parentName" label="家长" width="100" />
        <el-table-column prop="parentPhone" label="电话" width="130" />
        <el-table-column label="小课剩余" width="90">
          <template slot-scope="{ row }">
            <span :style="{ color: (row.privateRemainingHours || 0) <= 3 ? '#F56C6C' : '' }">
              {{ row.privateRemainingHours || 0 }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="欠课" width="70">
          <template slot-scope="{ row }">
            <span v-if="row.privateOwedHours > 0" style="color:#F56C6C">{{ row.privateOwedHours }}</span>
            <span v-else>0</span>
          </template>
        </el-table-column>
        <el-table-column label="抵小课" width="90">
          <template slot-scope="{ row }">
            <el-tag v-if="row.privateExchangeEnabled === 1" type="success" size="small">
              {{ row.privateExchangeRate }}大课=1小课
            </el-tag>
            <span v-else style="color:#C0C4CC">未开通</span>
          </template>
        </el-table-column>
        <el-table-column label="教练" width="100">
          <template slot-scope="{ row }">{{ row.privateCoachName || '未指定' }}</template>
        </el-table-column>
        <el-table-column label="操作" min-width="420">
          <template slot-scope="{ row }">
            <el-button size="mini" type="warning" @click="openRecharge(row)">小课充值</el-button>
            <el-button size="mini" @click="openGroupRecharge(row)">开通/充值大课</el-button>
            <el-button size="mini" plain @click="openExchange(row)">抵小课</el-button>
            <el-button size="mini" @click="bindCoach(row)">{{ row.privateCoachName ? '换教练' : '指定教练' }}</el-button>
            <el-button size="mini" type="success" @click="goPunch(row)">打卡</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 移动端卡片 -->
      <div class="mobile-list">
        <div v-for="row in list" :key="row.id" class="mobile-card">
          <div class="mobile-header">
            <span class="name">{{ row.name }}</span>
            <span class="hours">小课 {{ row.privateRemainingHours || 0 }} 课时</span>
          </div>
          <div class="mobile-meta">{{ row.parentName }} · {{ row.parentPhone }}</div>
          <div v-if="row.privateOwedHours > 0" class="mobile-owed">欠课 {{ row.privateOwedHours }} 课时</div>
          <div class="mobile-meta">教练：{{ row.privateCoachName || '未指定' }}</div>
          <div class="mobile-meta">
            <span v-if="row.privateExchangeEnabled === 1">{{ row.privateExchangeRate }}大课=1小课</span>
            <span v-else style="color:#C0C4CC">抵小课未开通</span>
          </div>
          <div class="mobile-actions">
            <el-button size="mini" type="warning" @click="openRecharge(row)">小课充值</el-button>
            <el-button size="mini" @click="openGroupRecharge(row)">开通/充值大课</el-button>
            <el-button size="mini" plain @click="openExchange(row)">抵小课</el-button>
            <el-button size="mini" @click="bindCoach(row)">{{ row.privateCoachName ? '换教练' : '指定教练' }}</el-button>
            <el-button size="mini" type="success" @click="goPunch(row)">打卡</el-button>
          </div>
        </div>
      </div>

      <el-pagination
        style="margin-top: 16px"
        @current-change="handlePageChange"
        :current-page="page"
        :page-size="size"
        :total="total"
        layout="total, prev, pager, next"
      />
    </el-card>

    <el-dialog title="小课充值" :visible.sync="rechargeVisible" width="90%" :style="{ maxWidth: '400px' }">
      <el-form label-width="90px">
        <el-form-item label="学生">{{ current.name }}</el-form-item>
        <el-form-item label="小课剩余">{{ current.privateRemainingHours || 0 }} 课时</el-form-item>
        <el-form-item label="欠课" v-if="current.privateOwedHours > 0">
          <span style="color:#F56C6C">{{ current.privateOwedHours }} 课时</span>
        </el-form-item>
        <el-form-item label="带课教练">
          <el-select v-model="rechargeForm.privateCoachId" filterable clearable placeholder="选填，上课教练登录即可划课" style="width:100%">
            <el-option v-for="c in coaches" :key="c.id" :label="c.name" :value="c.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="充值课时">
          <el-input-number v-model="rechargeForm.hours" :min="1" />
        </el-form-item>
        <el-form-item label="课程包">
          <el-input v-model="rechargeForm.packageName" />
        </el-form-item>
        <el-form-item label="金额">
          <el-input-number v-model="rechargeForm.amount" :min="0" :precision="2" />
        </el-form-item>
        <el-form-item label="凭证附件">
          <el-upload :show-file-list="false" :http-request="uploadAttach" accept="image/*,.pdf">
            <el-button size="mini">上传凭证</el-button>
          </el-upload>
          <div v-if="rechargeForm.attachmentUrl" style="margin-top:8px">
            <el-link :href="rechargeForm.attachmentUrl" target="_blank" type="primary">预览附件</el-link>
          </div>
        </el-form-item>
        <el-form-item label="大课抵小课">
          <el-switch v-model="rechargeForm.privateExchangeEnabled" active-text="同时开通" />
        </el-form-item>
        <el-form-item v-if="rechargeForm.privateExchangeEnabled" label="兑换比例">
          <el-input-number v-model="rechargeForm.privateExchangeRate" :min="2" :max="10" :step="1" />
          <span style="margin-left:8px">节大课 = 1 节小课</span>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="rechargeVisible = false">取消</el-button>
        <el-button type="primary" :loading="rechargeLoading" @click="submitRecharge">确认充值</el-button>
      </span>
    </el-dialog>

    <el-dialog title="开通 / 充值大课" :visible.sync="groupRechargeVisible" width="90%" :style="{ maxWidth: '400px' }">
      <el-form label-width="90px">
        <el-form-item label="学生">{{ current.name }}</el-form-item>
        <el-form-item label="大课剩余">{{ current.remainingHours || 0 }} 课时</el-form-item>
        <el-form-item label="充值课时">
          <el-input-number v-model="groupRechargeForm.hours" :min="1" />
        </el-form-item>
        <el-form-item label="课程包">
          <el-input v-model="groupRechargeForm.packageName" />
        </el-form-item>
        <el-form-item label="金额">
          <el-input-number v-model="groupRechargeForm.amount" :min="0" :precision="2" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="groupRechargeVisible = false">取消</el-button>
        <el-button type="primary" :loading="groupRechargeLoading" @click="submitGroupRecharge">确认充值</el-button>
      </span>
    </el-dialog>

    <el-dialog title="开通大课抵小课" :visible.sync="exchangeVisible" width="90%" :style="{ maxWidth: '400px' }">
      <el-form label-width="100px">
        <el-form-item label="学生">{{ current.name }}</el-form-item>
        <el-form-item label="开通">
          <el-switch v-model="exchangeForm.enabled" active-text="开通" inactive-text="关闭" />
        </el-form-item>
        <el-form-item v-if="exchangeForm.enabled" label="兑换比例">
          <el-input-number v-model="exchangeForm.rate" :min="2" :max="10" :step="1" />
          <span style="margin-left:8px">节大课 = 1 节小课</span>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="exchangeVisible = false">取消</el-button>
        <el-button type="primary" :loading="exchangeLoading" @click="submitExchange">保存</el-button>
      </span>
    </el-dialog>

    <el-dialog title="指定带课教练" :visible.sync="bindCoachVisible" width="90%" :style="{ maxWidth: '400px' }">
      <el-form label-width="90px">
        <el-form-item label="学员">{{ current.name }}</el-form-item>
        <el-form-item label="教练" required>
          <el-select v-model="bindCoachId" filterable placeholder="请选择教练" style="width:100%">
            <el-option v-for="c in coaches" :key="c.id" :label="c.name" :value="c.id" />
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="bindCoachVisible = false">取消</el-button>
        <el-button type="primary" :loading="bindCoachLoading" @click="submitBindCoach">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getPrivateStudents, privateRecharge, recharge, uploadAdminFile, updatePrivateExchange, listAdminCoaches, bindPrivateCoach } from '../../api'

export default {
  name: 'PrivateStudents',
  data() {
    return {
      keyword: '', list: [], page: 1, size: 20, total: 0, loading: false, coaches: [],
      rechargeVisible: false, rechargeLoading: false,
      groupRechargeVisible: false, groupRechargeLoading: false,
      exchangeVisible: false, exchangeLoading: false,
      bindCoachVisible: false, bindCoachLoading: false, bindCoachId: null,
      current: {},
      rechargeForm: { hours: 10, amount: 0, packageName: '小课充值', attachmentUrl: '', privateExchangeEnabled: false, privateExchangeRate: 2, privateCoachId: null },
      groupRechargeForm: { hours: 10, amount: 0, packageName: '开通大课' },
      exchangeForm: { enabled: false, rate: 2 }
    }
  },
  mounted() { this.loadData(); this.loadCoaches() },
  methods: {
    async loadCoaches() {
      try {
        const res = await listAdminCoaches({ page: 1, size: 100 })
        this.coaches = ((res.data && res.data.records) || []).filter(c => c.hasLoginAccount || c.adminUserId)
      } catch (e) {}
    },
    async loadData() {
      this.loading = true
      try {
        const res = await getPrivateStudents({ page: this.page, size: this.size, keyword: this.keyword })
        this.list = res.data.records || []
        this.total = res.data.total || 0
      } finally {
        this.loading = false
      }
    },
    handlePageChange(p) { this.page = p; this.loadData() },
    openRecharge(row) {
      this.current = row
      this.rechargeForm = {
        hours: 10,
        amount: 0,
        packageName: '小课充值',
        attachmentUrl: '',
        privateExchangeEnabled: false,
        privateExchangeRate: row.privateExchangeRate >= 2 ? row.privateExchangeRate : 2,
        privateCoachId: row.privateCoachId || null
      }
      this.rechargeVisible = true
    },
    openExchange(row) {
      this.current = row
      this.exchangeForm = {
        enabled: row.privateExchangeEnabled === 1,
        rate: row.privateExchangeRate >= 2 ? row.privateExchangeRate : 2
      }
      this.exchangeVisible = true
    },
    async uploadAttach({ file }) {
      const res = await uploadAdminFile(file)
      this.$set(this.rechargeForm, 'attachmentUrl', res.data.url)
      this.$message.success('凭证已上传')
    },
    openGroupRecharge(row) {
      this.current = row
      this.groupRechargeForm = { hours: 10, amount: 0, packageName: '开通大课' }
      this.groupRechargeVisible = true
    },
    async submitGroupRecharge() {
      this.groupRechargeLoading = true
      try {
        const res = await recharge(this.current.id, this.groupRechargeForm)
        this.$alert((res.data && res.data.message) || '充值成功', '大课充值成功')
        this.groupRechargeVisible = false
        this.loadData()
      } finally {
        this.groupRechargeLoading = false
      }
    },
    async submitRecharge() {
      this.rechargeLoading = true
      try {
        const payload = { ...this.rechargeForm }
        if (!payload.privateExchangeEnabled) {
          delete payload.privateExchangeEnabled
          delete payload.privateExchangeRate
        }
        const res = await privateRecharge(this.current.id, payload)
        this.$alert((res.data && res.data.message) || '充值成功', '充值成功')
        this.rechargeVisible = false
        this.loadData()
      } finally {
        this.rechargeLoading = false
      }
    },
    async submitExchange() {
      this.exchangeLoading = true
      try {
        await updatePrivateExchange(this.current.id, {
          enabled: this.exchangeForm.enabled,
          rate: this.exchangeForm.rate
        })
        this.$message.success(this.exchangeForm.enabled ? '已开通大课抵小课' : '已关闭')
        this.exchangeVisible = false
        this.loadData()
      } finally {
        this.exchangeLoading = false
      }
    },
    goPunch(row) {
      this.$router.push({ path: '/private/punch', query: { id: row.id, name: row.name } })
    },
    bindCoach(row) {
      if (!this.coaches.length) {
        this.$message.warning('请先给教练开通登录账号')
        return
      }
      this.current = row
      this.bindCoachId = row.privateCoachId || null
      this.bindCoachVisible = true
    },
    async submitBindCoach() {
      if (!this.bindCoachId) {
        this.$message.warning('请选择教练')
        return
      }
      this.bindCoachLoading = true
      try {
        await bindPrivateCoach(this.current.id, this.bindCoachId)
        this.$message.success('已指定教练')
        this.bindCoachVisible = false
        this.loadData()
      } finally {
        this.bindCoachLoading = false
      }
    }
  }
}
</script>

<style scoped>
.page-title { margin-bottom: 20px; }
.toolbar { margin-bottom: 16px; }
.toolbar .el-input { max-width: 320px; width: 100%; }
.mobile-list { display: none; }
.mobile-card {
  border: 1px solid #eee; border-radius: 8px; padding: 12px; margin-bottom: 12px;
}
.mobile-header { display: flex; justify-content: space-between; margin-bottom: 6px; }
.mobile-header .name { font-weight: bold; }
.mobile-header .hours { color: #67C23A; font-size: 13px; }
.mobile-meta { font-size: 13px; color: #999; margin-bottom: 8px; }
.mobile-owed { color: #F56C6C; font-size: 13px; margin-bottom: 8px; }
.mobile-actions { display: flex; flex-wrap: wrap; gap: 8px; }
.hint { font-size: 12px; color: #94A3B8; line-height: 1.4; }
@media (max-width: 768px) {
  .desktop-table { display: none; }
  .mobile-list { display: block; }
  .toolbar .el-input { max-width: 100%; }
}
</style>
